/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanReportOutputDto { 
    id?: number;
    loanAmount?: number;
    memberName?: string | null;
    memberAge?: string | null;
    memberGender?: string | null;
    memberReferenceId?: string | null;
    loanOfficeName?: string | null;
    loanProductName?: string | null;
    status?: string | null;
    loanReferenceId?: string | null;
}

